import React from "react";

import { Route } from "react-router";

import MyCharts from '../pages/myCharts/myCharts'


export const systemRouters = (
	<Route path="">
		<Route path="meus-mapas" component={(props) => <MyCharts {...props} />} />

	</Route>
);
